import { render, staticRenderFns } from "./RegisterPopSevenTrade.vue?vue&type=template&id=6c28320c&scoped=true&"
import script from "./RegisterPopSevenTrade.vue?vue&type=script&lang=js&"
export * from "./RegisterPopSevenTrade.vue?vue&type=script&lang=js&"
import style0 from "./RegisterPopSevenTrade.vue?vue&type=style&index=0&id=6c28320c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c28320c",
  null
  
)

component.options.__file = "RegisterPopSevenTrade.vue"
export default component.exports